import React, { ReactElement } from "react";
import styles from "./FloatLabel.module.scss";
import { SelectProps } from "../Select/Select";
import { InputTextProps } from "../InputText/InputText";
import clsx from "clsx";
import { PhoneInputProps } from "../PhoneInput/PhoneInput";
import { ValidationInputState } from "../../ValidationInputState";

export type FloatLabelInput =
  | ReactElement<InputTextProps>
  | ReactElement<SelectProps>
  | ReactElement<PhoneInputProps>;

export interface FloatLabelProps {
  id?: string;
  label: string;
  placeholder?: string;
  children: FloatLabelInput;
  forceFocus?: boolean;
  validationState?: ValidationInputState;
}

export const FloatLabel: React.FC<React.PropsWithChildren<FloatLabelProps>> = ({
  id,
  label,
  children,
  placeholder = " ",
  forceFocus,
  validationState = undefined,
  ...inputProps
}) => {
  return (
    <div
      className={clsx(styles.field, {
        [styles.withError]: validationState == "error"
      })}
    >
      {React.cloneElement(children, {
        className: `${children.props.className} ${styles.input}`,
        id,
        placeholder,
        ...inputProps
      })}
      <label
        htmlFor={id}
        className={clsx(styles.label, { [styles.forceFocus]: forceFocus })}
      >
        {label}
      </label>
    </div>
  );
};
